import { z } from "zod";

import { DatabaseDefaults } from "@/src/models/database-defaults";

export enum FaxDirection {
  INBOUND = "Inbound",
  OUTBOUND = "Outbound",
}

export enum FaxMessageStatus {
  QUEUED = "Queued",
  SENT = "Sent",
  DELIVERED = "Delivered",
  DELIVERY_FAILED = "DeliveryFailed",
  SENDING_FAILED = "SendingFailed",
  RECEIVED = "Received",
  FAILED = "Failed",
  RETRIED = "Retried",
}

export const FaxMessageStatuesToCheckSent = [FaxMessageStatus.QUEUED, FaxMessageStatus.DELIVERED];

export const FaxMessageStatuesToRetry = [FaxMessageStatus.DELIVERY_FAILED, FaxMessageStatus.SENDING_FAILED];

export const faxSchema = z.object({
  pathToFax: z.string().nullable(),
  taskId: z.string().nullable(),
  retrievalTime: z.string().nullable(),
  forwardedTime: z.string().nullable(),
  messageId: z.string().nullable(),
  creationTime: z.string().nullable(),
  messageStatus: z.nativeEnum(FaxMessageStatus).nullable(),
  direction: z.nativeEnum(FaxDirection).nullable(),
  recipientList: z.string().nullable(),
  retryFaxId: z.string().nullable(),
  retryCount: z.number().default(0),
  originalFaxId: z.string().nullable(),
  lastRetryTime: z.string().nullable(),
  fromNumber: z.string().nullable(),
  fromName: z.string().nullable(),
  pageCount: z.number().nullable(),
  lastModifiedTime: z.string().nullable(),
  fileId: z.string().nullable(),
});

export type Fax = z.infer<typeof faxSchema> & DatabaseDefaults;

export function getFaxLabels(fax: Fax) {
  return Object.fromEntries(Object.entries(fax).map(([key, value]) => [`fax_${key}`, String(value)]));
}

export const faxShape: Fax = {
  id: "",
  pathToFax: null,
  taskId: null,
  retrievalTime: null,
  forwardedTime: null,
  messageId: null,
  creationTime: null,
  messageStatus: null,
  direction: null,
  recipientList: null,
  retryFaxId: null,
  retryCount: 0,
  originalFaxId: null,
  lastRetryTime: null,
  fromNumber: null,
  fromName: null,
  pageCount: null,
  lastModifiedTime: null,
  fileId: null,
  groupId: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
};
